import { FETCH_CHECK_COUPON } from "store/types";

const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_CHECK_COUPON:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
